// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.easycommerce .easycommerce-order-action-modal-select-input {
    max-width: 100%;
    padding: 15px;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    color: var(--color-ec-body);
    border: 1px solid var(--color-ec-border);
    border-radius: 6px;
}
.easycommerce .easycommerce-order-action-modal-select-input:hover {
    color: var(--color-ec-body);
}
.easycommerce .easycommerce-order-action-modal-select-input:focus {
    color: var(--color-ec-body);
    outline: 0;
    border: 1px solid var(--color-ec-border);
    box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./spa/admin/easycommerce/pages/Orders/SingleOrder/style.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,2BAA2B;IAC3B,wCAAwC;IACxC,kBAAkB;AACtB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;IAC3B,UAAU;IACV,wCAAwC;IACxC,gBAAgB;AACpB","sourcesContent":[".easycommerce .easycommerce-order-action-modal-select-input {\n    max-width: 100%;\n    padding: 15px;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 26px;\n    color: var(--color-ec-body);\n    border: 1px solid var(--color-ec-border);\n    border-radius: 6px;\n}\n.easycommerce .easycommerce-order-action-modal-select-input:hover {\n    color: var(--color-ec-body);\n}\n.easycommerce .easycommerce-order-action-modal-select-input:focus {\n    color: var(--color-ec-body);\n    outline: 0;\n    border: 1px solid var(--color-ec-border);\n    box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
